// axios中请求配置有baseURL选项，表示请求URL公共部分。
// `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL
import Vue from 'vue'

export default {
  install(Vue) {

    // 接口基础URL，本地重命名.env.local.rename为.env.local，并修改为自己的接口地址
     //Vue.prototype.$baseURL = "https://www.sdgkbxjj.com.cn:8081/";
    // Vue.prototype.$baseURL = "http://27.223.14.166:9998/";
	// Vue.prototype.$baseURL = "https://www.sd-gxqh.com:9998/";
    //Vue.prototype.$baseURL = "http://localhost:8083/";
    //Vue.prototype.$baseURL = "http://10.193.117.1:8083/";
    Vue.prototype.$baseURL = "https://www.sdgkbxjj.com.cn/api";
    // ========================文章=================================
    Vue.prototype.$articleList = Vue.prototype.$baseURL + "/port/portal";
    Vue.prototype.$articleContent = Vue.prototype.$baseURL + "/port/getParticulars";
    //banner 友情链接
    Vue.prototype.$bannerList = Vue.prototype.$baseURL + "/banner/bannerList2";
    Vue.prototype.$bannerListEn = Vue.prototype.$baseURL + "/banner/bannerListEn";

    Vue.prototype.$linkList = Vue.prototype.$baseURL + "/link/linkList2";
	Vue.prototype.$compIntroHome = Vue.prototype.$baseURL + "/port/portal?typeId=6506&type=zh&categories=2";
	Vue.prototype.$compHistHome = Vue.prototype.$baseURL + "/port/portal?typeId=6512&type=zh&categories=2";
	Vue.prototype.$coopListHome = Vue.prototype.$baseURL + "/port/portal?typeId=6533&type=zh&categories=2&size=20";

	Vue.prototype.$footerList = Vue.prototype.$baseURL + "/siteinfo/footerInfo";

    //文章分类
    Vue.prototype.$navList = Vue.prototype.$baseURL + "/home/homeList2";
	Vue.prototype.$navListEn = Vue.prototype.$baseURL + "/home/homeListEn";

    //日期格式
    Vue.prototype.$dateTimeFormat = "YYYY-MM-DD HH:mm:ss";
    Vue.prototype.$commonDateTimeFormat = "YYYY-MM-DD HH:mm";
    Vue.prototype.$dateDay00Format = "YYYY-MM-DD 00:00:00";
    Vue.prototype.$dateDay24Format = "YYYY-MM-DD 24:00:00";
    Vue.prototype.$planShipDateDayFormat = "YYYYMMDDHHmm";
    Vue.prototype.$dateYearFormat = "YYYY";
    Vue.prototype.$dateMonthFormat = "YYYY-MM";
    Vue.prototype.$dateDayFormat = "YYYY-MM-DD";
    Vue.prototype.$dateFormat = "YYYY-MM-DD 18:00";
    Vue.prototype.$date23Format = "YYYY-MM-DD 23:59:59";
    Vue.prototype.$datejdTime = "YYYY-MM-DD HH:mm:00";
    Vue.prototype.$ribaoTime = "MM-DD HH:mm";



    Vue.prototype.$doAjax = function (url, param, callback) {
      this.postAxios(url, param).then((res) => {
        if (res.data.code === 0) {
          this.$message['success']({
            type: '提示',
            message: '操作成功!'
          });
          callback(res);
        } else {
          this.$message['error']({
            type: '提示',
            message: '操作失败!'
          });
        }
      }).catch((err) => {
        this.$errorCallback(err.response.status, err.message);
      })
    }
    Vue.prototype.$getAjax = function (url, param, callback) {
      this.getAxios(url, param).then((res) => {
        if (res.data.code === 0) {
          callback(res.data);
        } else {
          this.$message['error']({
            type: "error",
            message: res.message,
          });
        }
      }).catch((err) => {
        console.log(err);
        this.$errorCallback(err);
      })
    }
    //系统错误特殊处理
    Vue.prototype.$errorCallback = function (code, errMessage) {
        this.$message['error']({
          type: "error",
          message: "系统错误，请联系管理员！",
        });
      }
    }
}



// WEBPACK FOOTER //
// ./src/assets/api/common.js